import * as React from 'react';
import Icon from '@/components/ui/Icon';
import styles from './styles.module.scss';

const Tooltip: React.FunctionComponent<React.PropsWithChildren> = (props) => {
  return (
    <div className={styles['tooltip']}>
      <Icon
        width={20}
        height={20}
        kind="tooltip"
      />
      <div className={styles['tooltip__tip']}>{props.children}</div>
    </div>
  );
};

Tooltip.displayName = 'Tooltip';

export default Tooltip;
